import { GenericAbortSignal } from 'axios';

import { Paginated } from 'models/Paginated';
import { TourOptions } from 'models/Tour';
import http from 'services/http';

const PAGE_SIZE = 100;

// `groupIds` is the referral's groups the viewer holds: the card's denominator and the set Log tour offers.
type ToursPage = Paginated<TourOptions> & { groupIds: string[] };

export async function indexTours(workflowId: string, signal?: GenericAbortSignal) {
  const tours: TourOptions[] = [];
  for (let page = 1; ; page++) {
    const { data } = await http.get<ToursPage>(`/workflows/${workflowId}/tours`, {
      params: { page, pageSize: PAGE_SIZE },
      signal,
    });
    tours.push(...data.data);
    if (page >= data.meta.totalPages) return { tours, groupIds: data.groupIds };
  }
}

export async function createTour({
  workflowId,
  groupId,
  touredOn,
}: {
  workflowId: string;
  groupId: string;
  touredOn: string;
}) {
  return http
    .post<TourOptions>(`/workflows/${workflowId}/tours`, { groupId, touredOn })
    .then((response) => response.data);
}

export async function updateTour({ workflowId, id, touredOn }: { workflowId: string; id: string; touredOn: string }) {
  return http
    .patch<TourOptions>(`/workflows/${workflowId}/tours/${id}`, { touredOn })
    .then((response) => response.data);
}

export async function deleteTour({ workflowId, id }: { workflowId: string; id: string }) {
  return http.delete(`/workflows/${workflowId}/tours/${id}`);
}
